import React from 'react';

import {useAppStore} from "@lib/Context";
import almacenaLogo from '@assets/footer-almacena.png';
import proCafeLogo from '@assets/images/footer-procafe.png';

import styles from './footer.module.scss'

const Footer = () => {
  const { state: appState } = useAppStore();

  const renderWLLogo = () => {
    switch (appState?.userInfo?.whiteLabel) {
      case 'procafe':
        return (
          <img src={proCafeLogo} title={'Procafe'} />
        );
    }
  }

  return (
    <footer className={styles.footer}>
      <div className={styles.logoWrap}>
        {renderWLLogo()}
        <img src={almacenaLogo} title={'Almacena'} />
      </div>
    </footer>
  );
}

export default Footer;
